import React from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

function DetailsItems(props) {
    const items = props.items || [];

    return(
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Internal SKU</TableCell>
                    <TableCell>Quantity</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {items.map((item, index) => {
                    return(
                        <TableRow key = {index}>
                            <TableCell>{item.item}</TableCell>
                            <TableCell>{item.lotInfo[0].shippedQuantity}</TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </Table>
    )
}

export default DetailsItems;